export var PurchaseReason;
(function (PurchaseReason) {
    PurchaseReason["LoanApproval"] = "LOAN_APPROVAL";
    PurchaseReason["LoanEligibility"] = "LOAN_ELIGIBILITY";
    PurchaseReason["LoanAffordability"] = "LOAN_AFFORDABILITY";
})(PurchaseReason || (PurchaseReason = {}));
//# sourceMappingURL=PurchaseReason.js.map